module.exports = __webpack_public_path__ + "img/recognition-novikov.749e7df.gif";